{
  "INAPP-2270.spotlight.body": [
    {
      "type": 0,
      "value": "Collaborate on requirements, meetings notes, retros, and more."
    }
  ],
  "INAPP-2270.spotlight.primary": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "INAPP-2270.spotlight.secondary": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "INAPP-2270.spotlight.title": [
    {
      "type": 0,
      "value": "Create docs without leaving Jira"
    }
  ],
  "INAPP-2271.spotlight.body": [
    {
      "type": 0,
      "value": "Create a single source of truth for your project docs. It's free to try."
    }
  ],
  "INAPP-2271.spotlight.bodyV2": [
    {
      "type": 0,
      "value": "Use it to create a single source of truth for all of your project docs."
    }
  ],
  "INAPP-2271.spotlight.primary": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "INAPP-2271.spotlight.secondary": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "INAPP-2271.spotlight.title": [
    {
      "type": 0,
      "value": "You have Confluence!"
    }
  ],
  "growth-starburst.chloe-test-po-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "growth-starburst.chloe-test-po-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "growth-starburst.chloe-test-po-email.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "growth-starburst.chloe-test-po-email.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "growth-starburst.chloe-test-po-email.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "growth-starburst.chloe-test-po-email.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "growth-starburst.chloe-test-po-email.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "growth-starburst.common.arrow-right.alt-text": [
    {
      "type": 0,
      "value": "Arrow right"
    }
  ],
  "growth-starburst.common.bundled-existing-apps.header": [
    {
      "type": 0,
      "value": "Bundled with your existing apps"
    }
  ],
  "growth-starburst.common.icon-check-circle-blue.alt-text": [
    {
      "type": 0,
      "value": "Icon - Check circle"
    }
  ],
  "growth-starburst.common.icon-confluence.alt-text": [
    {
      "type": 0,
      "value": "Icon - Confluence"
    }
  ],
  "growth-starburst.common.icon-jira.alt-text": [
    {
      "type": 0,
      "value": "Icon - Jira"
    }
  ],
  "growth-starburst.common.icon-loom.alt-text": [
    {
      "type": 0,
      "value": "Icon - Loom"
    }
  ],
  "growth-starburst.common.icon-rovo.alt-text": [
    {
      "type": 0,
      "value": "Icon - Rovo"
    }
  ],
  "growth-starburst.common.percentage.alt-text": [
    {
      "type": 0,
      "value": "Percentage "
    },
    {
      "type": 1,
      "value": "percentage"
    }
  ],
  "growth-starburst.common.pro-tip.alt-text": [
    {
      "type": 0,
      "value": "Pro tip"
    }
  ],
  "growth-starburst.common.twc-email-summary.confluence": [
    {
      "children": [
        {
          "type": 0,
          "value": "Confluence"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " - Idea & knowledge sharing"
    }
  ],
  "growth-starburst.common.twc-email-summary.header": [
    {
      "type": 0,
      "value": "Your Teamwork Collection gives you access to:"
    }
  ],
  "growth-starburst.common.twc-email-summary.jira": [
    {
      "children": [
        {
          "type": 0,
          "value": "Jira"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " - Work planning & tracking"
    }
  ],
  "growth-starburst.common.twc-email-summary.loom": [
    {
      "children": [
        {
          "type": 0,
          "value": "Loom"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " - Async video communication"
    }
  ],
  "growth-starburst.common.twc-email-summary.rovo": [
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " - AI Chat, Search & a team of specialized Agents"
    }
  ],
  "growth-starburst.ep-migration-inapp-3280.description": [
    {
      "type": 0,
      "value": "We’ve put you on the Free plan of Confluence for now. You can add up to 10 users."
    }
  ],
  "growth-starburst.ep-migration-inapp-3280.primary-button": [
    {
      "type": 0,
      "value": "Upgrade options"
    }
  ],
  "growth-starburst.ep-migration-inapp-3280.secondary-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "growth-starburst.ep-migration-inapp-3280.title": [
    {
      "type": 0,
      "value": "We’re having trouble with your plan"
    }
  ],
  "growth-starburst.ep-migration-inapp-3282.description": [
    {
      "type": 0,
      "value": "We’ve kept you on the Standard plan of Confluence for now."
    }
  ],
  "growth-starburst.ep-migration-inapp-3282.primary-button": [
    {
      "type": 0,
      "value": "Upgrade options"
    }
  ],
  "growth-starburst.ep-migration-inapp-3282.secondary-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "growth-starburst.ep-migration-inapp-3282.title": [
    {
      "type": 0,
      "value": "We’re having trouble with your plan"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.description": [
    {
      "type": 0,
      "value": "Try summarizing or generating more content with AI. You can always come back to this panel."
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.title": [
    {
      "type": 0,
      "value": "Now it's your turn!"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.create-content.description": [
    {
      "type": 0,
      "value": "Try Keep adding content to your page. You can type /ai to prompt AI."
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.create-content.title": [
    {
      "type": 0,
      "value": "Now it's your turn!"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.documentation.description": [
    {
      "type": 0,
      "value": "Create docs directly in Jira to capture work, strategy, and more — with AI doing the heavy lifting."
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.documentation.title": [
    {
      "type": 0,
      "value": "Turn ideas into docs instantly with AI"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.description": [
    {
      "type": 0,
      "value": "Create video messages using Loom to talk through updates, feedback, or upcoming work."
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.title": [
    {
      "type": 0,
      "value": "Record & share videos"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.navigation.explore": [
    {
      "type": 0,
      "value": "Explore"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.navigation.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.navigation.progress": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": "/"
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.navigation.skip": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-enabled": [
    {
      "type": 0,
      "value": "enabled"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-label": [
    {
      "type": 0,
      "value": "Auto advance:"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss Tour"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.start-from-step-label": [
    {
      "type": 0,
      "value": "Start from step:"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.steps-label": [
    {
      "type": 0,
      "value": "Steps:"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.title": [
    {
      "type": 0,
      "value": "TWC Spotlight Tour Test"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step1.description": [
    {
      "type": 0,
      "value": "Create, update and manage Jira work directly in Confluence docs."
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step1.header": [
    {
      "type": 0,
      "value": "Create and update tasks in Jira"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step1.progressIndicator": [
    {
      "type": 0,
      "value": "1 of 3"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step2.description": [
    {
      "type": 0,
      "value": "Generate content easily and quickly with our AI-powered writing assistant. Type /rovo to try it now."
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step2.header": [
    {
      "type": 0,
      "value": "Let AI do the writing for you"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step2.progressIndicator": [
    {
      "type": 0,
      "value": "2 of 3"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step3.description": [
    {
      "type": 0,
      "value": "Loom can create a script from your page content. Record a quick video and add it to your doc to explain updates."
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step3.header": [
    {
      "type": 0,
      "value": "Share updates with video"
    }
  ],
  "growth-starburst.twc-conf-sample-page-tour.step3.progressIndicator": [
    {
      "type": 0,
      "value": "3 of 3"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-confluence": [
    {
      "type": 0,
      "value": "Create documents in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Confluence"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to share knowledge"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-jira": [
    {
      "type": 0,
      "value": "Use "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Jira"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to organize and plan projects"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-loom.premium": [
    {
      "type": 0,
      "value": "Save time with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Loom"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and get AI-generated meeting recaps"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-loom.standard": [
    {
      "type": 0,
      "value": "Save time with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Loom"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and record async video updates"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-rovo": [
    {
      "type": 0,
      "value": "Get AI-powered help and keep work moving with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.description": [
    {
      "type": 0,
      "value": "Teamwork Collection brings together Jira, Confluence, Loom, and Rovo so you can plan, document, and collaborate across teams—all in one place."
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.explore-features-link": [
    {
      "type": 0,
      "value": "Explore all features →"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.features-title": [
    {
      "type": 0,
      "value": "Finish work 3x faster with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.footer.address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.get-started-button": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.heading": [
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " requested to try Teamwork Collection"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.logo.alt": [
    {
      "type": 0,
      "value": "Teamwork Collection Atlassian"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.trial-info.premium": [
    {
      "type": 0,
      "value": "Grant access on a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "free"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", 30-day trial of Premium."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Cancel anytime"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", we'll remind you 3 days before your trial ends."
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.trial-info.standard": [
    {
      "type": 0,
      "value": "Grant access on a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "free"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", 14-day trial of Standard."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Cancel anytime"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", we'll remind you 3 days before your trial ends."
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.body.visual.alt": [
    {
      "type": 0,
      "value": "Teamwork Collection visual showing Jira, Confluence, Loom, and Rovo"
    }
  ],
  "growth-starburst.twc-end-user-request-admin-email.message-template.email.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " wants to try Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Try free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraConf": [
    {
      "type": 0,
      "value": "Try free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Jump into Teamwork Collection now!"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraConf": [
    {
      "type": 0,
      "value": "Jump into Teamwork Collection now!"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraConf": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Try Teamwork Collection - Free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraConf": [
    {
      "type": 0,
      "value": "Try Teamwork Collection - Free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Accelerate teamwork 3x faster with video and AI, at "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "no added cost"
        }
      ],
      "type": 8,
      "value": "blue"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraConf": [
    {
      "type": 0,
      "value": "Accelerate teamwork 3x faster with video and AI, at "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "no added cost"
        }
      ],
      "type": 8,
      "value": "blue"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Save time with AI-generated meeting notes and async video"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraConf": [
    {
      "type": 0,
      "value": "Record and share videos to stay in sync without extra meetings."
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "faster project completion with"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraConf": [
    {
      "type": 0,
      "value": "faster project completion with"
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step2Description.jiraConf": [
    {
      "type": 0,
      "value": "Use AI to search through all docs and channels to find the right info."
    }
  ],
  "growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step2Title.jiraConf": [
    {
      "type": 0,
      "value": "less time searching for work with"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Copy1.confluenceArticle": [
    {
      "type": 0,
      "value": "Start with a simple prompt like \"plan a Q3 launch\" and let Rovo draft a structured project plan."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Copy1.jiraArticle": [
    {
      "type": 0,
      "value": "Start with a simple prompt like \"plan a Q3 launch\" and let Rovo draft a structured project plan."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Copy1.jiraConfArticle": [
    {
      "type": 0,
      "value": "Start with a simple prompt like \"plan a Q3 launch\" and let Rovo draft a structured project plan. Turn key milestones into Jira work items, with fields, assignees, and due dates pre‑filled and linked back to a plan in Confluence."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Copy2.confluenceArticle": [
    {
      "type": 0,
      "value": "Turn key milestones into Jira issues, with fields, assignees, and due dates pre‑filled and linked back to your plan in Confluence."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Copy2.jiraArticle": [
    {
      "type": 0,
      "value": "Turn key milestones into Jira work items, with fields, assignees, and due dates pre‑filled and linked back to a plan in Confluence."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Copy2.jiraConfArticle": [
    {
      "type": 0,
      "value": "Add a Loom recording to your pages & tickets to keep your teams up to date!"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Subhead.confluenceArticle": [
    {
      "type": 0,
      "value": "From project idea → structured plan"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Subhead.jiraArticle": [
    {
      "type": 0,
      "value": "From project idea → structured plan"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article1Subhead.jiraConfArticle": [
    {
      "type": 0,
      "value": "From project idea → structured plan"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Copy1.confluenceArticle": [
    {
      "type": 0,
      "value": "Write specs in Confluence, create linked Jira work items with tasks, owners, and due dates."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Copy1.jiraArticle": [
    {
      "type": 0,
      "value": "Confluence captures your project plans, notes, and decision logs as organized knowledge that stays connected to your Jira work."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Copy1.jiraConfArticle": [
    {
      "type": 0,
      "value": "Confluence captures your project plans, notes, and decision logs as organized knowledge that stays connected to your Jira work."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Copy2.confluenceArticle": [
    {
      "type": 0,
      "value": "No more \"Who picked this?\" or \"Who's on point?\" weeks later."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Copy2.jiraArticle": [
    {
      "type": 0,
      "value": "See the \"why\" and \"how\" behind any work item – no digging required."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Copy2.jiraConfArticle": [
    {
      "type": 0,
      "value": "See the \"why\" and \"how\" behind any work item – no digging required."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Subhead.confluenceArticle": [
    {
      "type": 0,
      "value": "Product requirements → Development tickets"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Subhead.jiraArticle": [
    {
      "type": 0,
      "value": "Docs and decisions that stay in sync with issues"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article2Subhead.jiraConfArticle": [
    {
      "type": 0,
      "value": "Docs and decisions that stay in sync with issues"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Copy1.confluenceArticle": [
    {
      "type": 0,
      "value": "Drop Loom videos straight into Confluence pages and Jira work items to add instant visual context and reduce confusion."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Copy1.jiraArticle": [
    {
      "type": 0,
      "value": "Drop Loom videos straight into Jira work items and Confluence pages to add instant visual context and reduce confusion."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Copy1.jiraConfArticle": [
    {
      "type": 0,
      "value": "Add Instant Visual Context: Embed Loom videos directly into your Jira issues and Confluence pages to clearly explain complex ideas and reduce confusion. Automate Next Steps: Let AI automatically summarize your recordings, extract key feedback, and link action items directly to your work."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Copy2.confluenceArticle": [
    {
      "type": 0,
      "value": "Then let Loom AI auto‑capture feedback, summarize meetings, and turn recordings into action items so work keeps moving forward without more meetings."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Copy2.jiraArticle": [
    {
      "type": 0,
      "value": "Then let Loom AI auto‑capture feedback, summarize meetings, and turn recordings into action items so work keeps moving forward without more meetings."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Copy2.jiraConfArticle": [
    {
      "type": 0,
      "value": "Eliminate Additional Meetings: Keep your team perfectly aligned and work moving forward asynchronously"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Subhead.confluenceArticle": [
    {
      "type": 0,
      "value": "Async updates without more meetings"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Subhead.jiraArticle": [
    {
      "type": 0,
      "value": "Async updates without more meetings"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.article3Subhead.jiraConfArticle": [
    {
      "type": 0,
      "value": "Async updates without more meetings"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.articleHeader.confluenceArticle": [
    {
      "type": 0,
      "value": "Here's how teams use Teamwork Collection:"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.articleHeader.jiraArticle": [
    {
      "type": 0,
      "value": "Here's how teams use Teamwork Collection:"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.articleHeader.jiraConfArticle": [
    {
      "type": 0,
      "value": "Here's how teams use Teamwork Collection:"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.confluenceArticle": [
    {
      "type": 0,
      "value": "Your best work already starts in Confluence. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Teamwork Collection"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": " helps you get to results faster."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.confluenceData": [
    {
      "type": 0,
      "value": "Teams that use Teamwork Collection see one consistent pattern: less chaos and faster progress on the work."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.confluencePlatform": [
    {
      "type": 0,
      "value": "Confluence is where your team thinks: project plans, decision logs, documentation, meeting notes, etc.\n\nBut after you agree on what to do, work frequently scatters into different tools and channels. Tasks get lost, updates go stale, and stakeholders aren't sure where to look for the latest.\n\n"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Teamwork Collection"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": " closes that gap. \n\nTeamwork Collection combines "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Jira + Confluence + Loom + Rovo AI"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " into one connected workspace."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.jiraArticle": [
    {
      "type": 0,
      "value": "With Teamwork Collection, Jira remains the structured backbone of your work, but your teams also get shared context, knowledge, and AI to help them go further, faster."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfArticle": [
    {
      "type": 0,
      "value": "With Teamwork Collection, Jira & Confluence remain the structured backbones of your work, but your teams also get shared context, knowledge, and AI to help them go further, faster."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfData": [
    {
      "type": 0,
      "value": "You already have a head start with Jira and Confluence. Upgrading to Teamwork Collection adds Loom and Rovo AI, bringing one consistent pattern to your workflows: less chaos and faster progress on the work."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfDataHasRovo": [
    {
      "type": 0,
      "value": "You already have a head start with Jira and Confluence. Upgrading to Teamwork Collection adds Loom, bringing one consistent pattern to your workflows: less chaos and faster progress on the work."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Confluence and Jira already help you plan and track your work. Adding Loom and Rovo to your tools brings greater clarity, faster progress, and improved teamwork."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfPlatformHasRovo": [
    {
      "type": 0,
      "value": "Confluence and Jira already help you plan and track your work. Adding Loom to your tools brings greater clarity, faster progress, and improved teamwork."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.jiraData": [
    {
      "type": 0,
      "value": "Teams that use Teamwork Collection see one consistent pattern: less chaos and faster progress on the work."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bodyCopy.jiraPlatform": [
    {
      "type": 0,
      "value": "Teamwork Collection brings Jira, Confluence, Loom, and Rovo AI together, augmenting your work already in Jira with clearer plans, shared context, and fewer status meetings."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet1.confluenceData": [
    {
      "children": [
        {
          "type": 0,
          "value": "3x faster delivery"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Less app switching and manual copy‑pasting across tools"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet1.confluencePlatform": [
    {
      "type": 0,
      "value": "Plan and document in Confluence"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet1.jiraConfData": [
    {
      "children": [
        {
          "type": 0,
          "value": "3x faster delivery"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Less app switching and manual copy-pasting across tools"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet1.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Plan and track work in Jira, with Rovo AI agents as teammates"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet1.jiraData": [
    {
      "children": [
        {
          "type": 0,
          "value": "3x faster delivery"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Less app switching and manual copy-pasting across tools"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet1.jiraPlatform": [
    {
      "type": 0,
      "value": "Plan and track work in Jira, with Rovo AI agents as teammates"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet2.confluenceData": [
    {
      "children": [
        {
          "type": 0,
          "value": "50% less time searching for info"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Teams align faster with everyone seeing the same source of truth"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet2.confluencePlatform": [
    {
      "type": 0,
      "value": "Track and execute in Jira"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet2.jiraConfData": [
    {
      "children": [
        {
          "type": 0,
          "value": "50% less time searching for info"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Teams align faster with everyone seeing the same source of truth"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet2.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Capture project plans, notes, and decision logs in Confluence and keep them tied to the right work items"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet2.jiraData": [
    {
      "children": [
        {
          "type": 0,
          "value": "50% less time searching for info"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Teams align faster with everyone seeing the same source of truth"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet2.jiraPlatform": [
    {
      "type": 0,
      "value": "Capture project plans, notes, and decision logs in Confluence and keep them tied to the right work items"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet3.confluenceData": [
    {
      "children": [
        {
          "type": 0,
          "value": "31% increase in project success"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Rovo AI helps teams unlock the knowledge buried in projects"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet3.confluencePlatform": [
    {
      "type": 0,
      "value": "Share updates asynchronously with Loom"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet3.jiraConfData": [
    {
      "children": [
        {
          "type": 0,
          "value": "31% increase in project success"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Rovo AI helps teams unlock the knowledge buried in projects"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet3.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Share quick Loom updates instead of scheduling another live meeting"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet3.jiraData": [
    {
      "children": [
        {
          "type": 0,
          "value": "31% increase in project success"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ": Rovo AI helps teams unlock the knowledge buried in projects"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet3.jiraPlatform": [
    {
      "type": 0,
      "value": "Share quick Loom updates instead of scheduling another live meeting"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet4.confluencePlatform": [
    {
      "type": 0,
      "value": "Use Rovo AI to augment your work"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet4.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Use Rovo to help draft plans, summarize changes, and surface what matters from across your tools"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bullet4.jiraPlatform": [
    {
      "type": 0,
      "value": "Use Rovo to help draft plans, summarize changes, and surface what matters from across your tools"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bulletHeader.confluenceData": [
    {
      "type": 0,
      "value": "With Teamwork Collection, teams report:"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bulletHeader.confluencePlatform": [
    {
      "type": 0,
      "value": "With Teamwork Collection, your team can:"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bulletHeader.jiraConfData": [
    {
      "type": 0,
      "value": "With Teamwork Collection, teams report:"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bulletHeader.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Teamwork Collection upgrades your workspace by adding Loom for quick, asynchronous video updates and Rovo to connect the dots. Now, your team can see the plan, track the status, and watch the context—all in one place."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bulletHeader.jiraData": [
    {
      "type": 0,
      "value": "With Teamwork Collection, teams report:"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.bulletHeader.jiraPlatform": [
    {
      "type": 0,
      "value": "With Teamwork Collection, your team can:"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.closingLine.confluenceData": [
    {
      "type": 0,
      "value": "Teamwork Collection brings the power of connected Atlassian tools to your Confluence docs."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.closingLine.confluencePlatform": [
    {
      "type": 0,
      "value": "The result: one platform to run the whole project."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.closingLine.jiraConfData": [
    {
      "type": 0,
      "value": "Teamwork Collection brings the power of connected Atlassian tools to your Jira and Confluence workspace."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.closingLine.jiraConfPlatform": [
    {
      "type": 0,
      "value": "The result: one intelligent platform to run the whole project."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.closingLine.jiraData": [
    {
      "type": 0,
      "value": "Teamwork Collection brings the power of connected Atlassian tools to your Jira projects."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.closingLine.jiraPlatform": [
    {
      "type": 0,
      "value": "The result: one intelligent platform to run the whole project."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.confluenceArticle": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.confluenceData": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.confluencePlatform": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.jiraArticle": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.jiraConfArticle": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.jiraConfData": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.jiraData": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.ctaText.jiraPlatform": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.confluenceArticle": [
    {
      "type": 0,
      "value": "Extend Confluence with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.confluenceData": [
    {
      "type": 0,
      "value": "Get 3x faster delivery with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.confluencePlatform": [
    {
      "type": 0,
      "value": "Your plans live in Confluence. Where is the work?"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.jiraArticle": [
    {
      "type": 0,
      "value": "Elevate Jira with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfArticle": [
    {
      "type": 0,
      "value": "Elevate Jira and Confluence workflows with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfData": [
    {
      "type": 0,
      "value": "3 ways to speed up your Jira & Confluence workflows"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Add context to your workflows with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.jiraData": [
    {
      "type": 0,
      "value": "Elevate Jira with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.emailSubject.jiraPlatform": [
    {
      "type": 0,
      "value": "Elevate Jira with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.confluenceArticle": [
    {
      "type": 0,
      "value": "Take Confluence further with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.confluenceData": [
    {
      "type": 0,
      "value": "Get the most out of Confluence with Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.confluencePlatform": [
    {
      "type": 0,
      "value": "One intelligent platform to run the whole project"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.jiraArticle": [
    {
      "type": 0,
      "value": "One intelligent platform to run the whole project"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.jiraConfArticle": [
    {
      "type": 0,
      "value": "One intelligent platform to run the whole project"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.jiraConfData": [
    {
      "type": 0,
      "value": "One intelligent platform to run the whole project"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.jiraConfPlatform": [
    {
      "type": 0,
      "value": "One intelligent platform to run the whole project"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.jiraData": [
    {
      "type": 0,
      "value": "One intelligent platform to run the whole project"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.headline.jiraPlatform": [
    {
      "type": 0,
      "value": "One intelligent platform to run the whole project"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.confluenceArticle": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.confluenceData": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.confluencePlatform": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.jiraArticle": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfArticle": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfData": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.jiraData": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.heroAlt.jiraPlatform": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.confluenceArticle": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.confluenceData": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.confluencePlatform": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.jiraArticle": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.jiraConfArticle": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.jiraConfData": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.jiraData": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroText.jiraPlatform": [
    {
      "type": 0,
      "value": "Try Teamwork Collection free"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroTitle.confluenceArticle": [
    {
      "type": 0,
      "value": "Ready to try Teamwork Collection for free?"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroTitle.jiraArticle": [
    {
      "type": 0,
      "value": "Ready to try Teamwork Collection for free?"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.outroTitle.jiraConfArticle": [
    {
      "type": 0,
      "value": "Ready to try Teamwork Collection for free?"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.confluenceArticle": [
    {
      "type": 0,
      "value": "Pages -> projects, decisions -> action, updates -> insight"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.confluenceData": [
    {
      "type": 0,
      "value": "Add plans, context, video, and AI to your work"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.confluencePlatform": [
    {
      "type": 0,
      "value": "Connect planning, documentation, and delivery"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.jiraArticle": [
    {
      "type": 0,
      "value": "Connect work, knowledge, and updates in one place"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.jiraConfArticle": [
    {
      "type": 0,
      "value": "Add video, summaries and data-driven context to your updates in one place"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.jiraConfData": [
    {
      "type": 0,
      "value": "Connect work, knowledge, and updates in one place with Video and AI context."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.jiraConfPlatform": [
    {
      "type": 0,
      "value": "Bridge the gap between planning and execution with clarity."
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.jiraData": [
    {
      "type": 0,
      "value": "Connect work, knowledge, and updates in one place"
    }
  ],
  "growth-starburst.twc-marketing-email-v2.preheader.jiraPlatform": [
    {
      "type": 0,
      "value": "Connect work, knowledge, and updates in one place"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.buttonText.conf": [
    {
      "type": 0,
      "value": "Try free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.buttonText.confAndLoom": [
    {
      "type": 0,
      "value": "Try free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.buttonText.jira": [
    {
      "type": 0,
      "value": "Try free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Try free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndLoom": [
    {
      "type": 0,
      "value": "Try free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraConf": [
    {
      "type": 0,
      "value": "Try free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingDescription.conf": [
    {
      "type": 0,
      "value": "Jump into Teamwork Collection now!"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingDescription.confAndLoom": [
    {
      "type": 0,
      "value": "Jump into Teamwork Collection now!"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingDescription.jira": [
    {
      "type": 0,
      "value": "Jump into Teamwork Collection now!"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Jump into Teamwork Collection now!"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndLoom": [
    {
      "type": 0,
      "value": "Jump into Teamwork Collection now!"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraConf": [
    {
      "type": 0,
      "value": "Jump into Teamwork Collection now!"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingTitle.conf": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingTitle.confAndLoom": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingTitle.jira": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndLoom": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraConf": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.emailSubject.conf": [
    {
      "type": 0,
      "value": "Try Teamwork Collection - Free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.emailSubject.confAndLoom": [
    {
      "type": 0,
      "value": "Try Teamwork Collection - Free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.emailSubject.jira": [
    {
      "type": 0,
      "value": "Try Teamwork Collection - Free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Try Teamwork Collection - Free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndLoom": [
    {
      "type": 0,
      "value": "Try Teamwork Collection - Free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraConf": [
    {
      "type": 0,
      "value": "Try Teamwork Collection - Free for 30 days"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.header.conf": [
    {
      "type": 0,
      "value": "Boost your team's productivity with connected tools built to work together"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.header.confAndLoom": [
    {
      "type": 0,
      "value": "Boost your team's productivity with connected tools built to work together"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.header.jira": [
    {
      "type": 0,
      "value": "Boost your team's productivity with connected tools built to work together"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.header.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Accelerate teamwork "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "3x faster"
        }
      ],
      "type": 8,
      "value": "blue"
    },
    {
      "type": 0,
      "value": " with video and AI"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.header.jiraAndLoom": [
    {
      "type": 0,
      "value": "Boost your team's productivity with connected tools built to work together"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.header.jiraConf": [
    {
      "type": 0,
      "value": "Boost your team's productivity with connected tools built to work together"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Description.conf": [
    {
      "type": 0,
      "value": "The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Description.confAndLoom": [
    {
      "type": 0,
      "value": "The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Description.jira": [
    {
      "type": 0,
      "value": "Create strategy docs, flowcharts, project plans, and more — without leaving Jira."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "Reduce repetitive syncs and follow-ups — Loom videos and automated recaps keep everyone aligned."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndLoom": [
    {
      "type": 0,
      "value": "Create strategy docs, flowcharts, project plans, and more — without leaving Jira."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraConf": [
    {
      "type": 0,
      "value": "Record and share videos to stay in sync without extra meetings."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Title.conf": [
    {
      "type": 0,
      "value": "increase speed in decision making"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Title.confAndLoom": [
    {
      "type": 0,
      "value": "increase speed in decision making"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Title.jira": [
    {
      "type": 0,
      "value": "boost in project completion with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndConfAndRovo": [
    {
      "type": 0,
      "value": "fewer meetings with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndLoom": [
    {
      "type": 0,
      "value": "boost in project completion with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraConf": [
    {
      "type": 0,
      "value": "fewer meetings with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Description.conf": [
    {
      "type": 0,
      "value": "Record and share videos to stay in sync without extra meetings."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Description.confAndLoom": [
    {
      "type": 0,
      "value": "Use AI to search through all docs and channels to find the right info."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Description.jira": [
    {
      "type": 0,
      "value": "Record and share videos to stay in sync without extra meetings."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraAndLoom": [
    {
      "type": 0,
      "value": "Use AI to search through all docs and channels to find the right info."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraConf": [
    {
      "type": 0,
      "value": "Use AI to search through all docs and channels to find the right info."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Title.conf": [
    {
      "type": 0,
      "value": "fewer meetings with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Title.confAndLoom": [
    {
      "type": 0,
      "value": "less time searching for work with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Title.jira": [
    {
      "type": 0,
      "value": "fewer meetings with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraAndLoom": [
    {
      "type": 0,
      "value": "less time searching for work with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraConf": [
    {
      "type": 0,
      "value": "less time searching for work with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step3Description.conf": [
    {
      "type": 0,
      "value": "Use AI to search through all docs and channels to find the right info."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step3Description.jira": [
    {
      "type": 0,
      "value": "Use AI to search through all docs and channels to find the right info."
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step3Title.conf": [
    {
      "type": 0,
      "value": "less time searching for work with"
    }
  ],
  "growth-starburst.twc-marketing-email.message-template.email.step3Title.jira": [
    {
      "type": 0,
      "value": "less time searching for work with"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.conf": [
    {
      "type": 0,
      "value": "Start with Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jira": [
    {
      "type": 0,
      "value": "Start with Confluence"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jiraConf": [
    {
      "type": 0,
      "value": "Start with Loom"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.land": [
    {
      "type": 0,
      "value": "Start with Confluence"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.conf": [
    {
      "type": 0,
      "value": "Try Jira today to make getting work done a snap!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jira": [
    {
      "type": 0,
      "value": "Try Confluence today to start connecting org-wide knowledge to your work."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jiraConf": [
    {
      "type": 0,
      "value": "Record your first Loom video today to show (not tell) what you're working on."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.land": [
    {
      "type": 0,
      "value": "Try out Confluence today to add context to your work in Jira."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.conf": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jira": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jiraConf": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.land": [
    {
      "type": 0,
      "value": "Bring your next big idea to life"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.content.conf": [
    {
      "type": 0,
      "value": "Use Jira to visualize your tasks and workflows. Plus, use AI-powered automations to get the whole team get moving fast."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.content.jira": [
    {
      "type": 0,
      "value": "Use Confluence to capture notes, draft plans, share project insights. Plus, keep it all organized alongside Jira."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.content.jiraConf": [
    {
      "type": 0,
      "value": "Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.content.land": [
    {
      "type": 0,
      "value": "Hit “Create” in Confluence to jot down notes, draft plans, or share learnings. Pick a ready-made template to start fast."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.conf": [
    {
      "type": 0,
      "value": "🏎️ Kickstart collaboration with Jira & Confluence"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jira": [
    {
      "type": 0,
      "value": "🏎️ Kickstart collaboration with Confluence & Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jiraConf": [
    {
      "type": 0,
      "value": "🎬 Start your first Loom recording today"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.land": [
    {
      "type": 0,
      "value": "🖼️ See the full picture for your projects"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.header.conf": [
    {
      "type": 0,
      "value": "Plan it, track it, get it done"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.header.jira": [
    {
      "type": 0,
      "value": "Go from cluttered docs to organized knowledge"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.header.jiraConf": [
    {
      "type": 0,
      "value": "Capture context in a single click"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.header.land": [
    {
      "type": 0,
      "value": "Say “goodbye” to boring project docs"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.conf": [
    {
      "type": 0,
      "value": "Start with Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jira": [
    {
      "type": 0,
      "value": "Start with Confluence"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jiraConf": [
    {
      "type": 0,
      "value": "Start with Loom"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.land": [
    {
      "type": 0,
      "value": "Start with Confluence"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.conf": [
    {
      "type": 0,
      "value": "Try it out"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jira": [
    {
      "type": 0,
      "value": "Try it out"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jiraConf": [
    {
      "type": 0,
      "value": "Try it out"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.conf": [
    {
      "type": 0,
      "value": "Add Jira views as "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Smart Links"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in Confluence to help keep everyone in sync"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jira": [
    {
      "type": 0,
      "value": "Add Confluence docs as "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Smart Links"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in Jira to help keep everyone in sync"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jiraConf": [
    {
      "type": 0,
      "value": "Add Loom videos as "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Smart Links"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in Jira and Confluence to keep the team in sync"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.conf": [
    {
      "type": 0,
      "value": "Pro tip!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jira": [
    {
      "type": 0,
      "value": "Pro tip!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jiraConf": [
    {
      "type": 0,
      "value": "Pro tip!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.conf": [
    {
      "type": 0,
      "value": "Use a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "board"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to arrange issues in columns, or plot work out on a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "timeline"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "calendar"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " over months or quarters."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jira": [
    {
      "type": 0,
      "value": "Add Jira boards, Google forms, Figma designs, Excel spreadsheets & more—right into Confluence. It's your team's new single source of truth!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jiraConf": [
    {
      "type": 0,
      "value": "Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.land": [
    {
      "type": 0,
      "value": "Embed Jira views, reports, and forms directly into Confluence pages with Smart Links."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.conf": [
    {
      "type": 0,
      "value": "View it your way"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jira": [
    {
      "type": 0,
      "value": "Connect your work from anywhere"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jiraConf": [
    {
      "type": 0,
      "value": "Add clarity instantly"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.land": [
    {
      "type": 0,
      "value": "Keep it all in sync"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.conf": [
    {
      "type": 0,
      "value": "Let AI automatically transform Confluence notes into trackable work in Jira—no copy-pasting or re-typing needed."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jira": [
    {
      "type": 0,
      "value": "Let AI automatically transform Confluence notes into trackable work in Jira—no copy-pasting or re-typing needed."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jiraConf": [
    {
      "type": 0,
      "value": "Get automated meeting recaps—with summaries and action items, so nothing slips through the cracks."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.land": [
    {
      "type": 0,
      "value": "Let AI automatically turn Confluence pages and whiteboards into trackable work in Jira."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.conf": [
    {
      "type": 0,
      "value": "Auto-capture action items"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jira": [
    {
      "type": 0,
      "value": "Auto-capture action items"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jiraConf": [
    {
      "type": 0,
      "value": "Take notes, without writing a single word"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.land": [
    {
      "type": 0,
      "value": "Transform ideas into action"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.conf": [
    {
      "type": 0,
      "value": "Create and edit Confluence docs and whiteboards right inside Jira to help your team stay connected all in one tool."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jira": [
    {
      "type": 0,
      "value": "Create and edit docs, whiteboards (anything, really!) right inside Confluence to help your team stay connected all in one tool."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jiraConf": [
    {
      "type": 0,
      "value": "Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.land": [
    {
      "type": 0,
      "value": "View, edit, and create Confluence pages and whiteboards right from Jira, without losing context."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.conf": [
    {
      "type": 0,
      "value": "Never switch context again!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jira": [
    {
      "type": 0,
      "value": "Never switch context again!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jiraConf": [
    {
      "type": 0,
      "value": "Turn recordings into action"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.land": [
    {
      "type": 0,
      "value": "View work across teams"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.subheader.conf": [
    {
      "type": 0,
      "value": "Our top tips for planning and tracking work:"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jira": [
    {
      "type": 0,
      "value": "Our top tips for connecting team knowledge:"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jiraConf": [
    {
      "type": 0,
      "value": "How to work with AI-powered videos:"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.subheader.land": [
    {
      "type": 0,
      "value": "How to plan, track, and doc with Confluence and Jira:"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.conf": [
    {
      "type": 0,
      "value": "Start with Loom"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jira": [
    {
      "type": 0,
      "value": "Start with Loom"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jiraConf": [
    {
      "type": 0,
      "value": "Explore Rovo AI"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.land": [
    {
      "type": 0,
      "value": "Start with Loom"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.conf": [
    {
      "type": 0,
      "value": "Record your first Loom video today to show (not tell) what you're working on."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jira": [
    {
      "type": 0,
      "value": "Record your first Loom video today to show (not tell) what you're working on."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jiraConf": [
    {
      "type": 0,
      "value": "Chat with Rovo AI today to get on the fast-track to productivity."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.land": [
    {
      "type": 0,
      "value": "Record your first Loom video today to show (not tell) what you're working on."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.conf": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jira": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jiraConf": [
    {
      "type": 0,
      "value": "Ready to try out Rovo AI?"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.land": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.content.conf": [
    {
      "type": 0,
      "value": "Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.content.jira": [
    {
      "type": 0,
      "value": "Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.content.jiraConf": [
    {
      "type": 0,
      "value": "Summarize, search, and streamline any task. No context-switching, no searching—just better results."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.content.land": [
    {
      "type": 0,
      "value": "Record a Loom video to add visual context to project updates, presentations, and training materials in Jira and Confluence."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.conf": [
    {
      "type": 0,
      "value": "🎬 Start your first Loom recording today"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jira": [
    {
      "type": 0,
      "value": "🎬 Start your first Loom recording today"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jiraConf": [
    {
      "type": 0,
      "value": "🤫 Your secret to better, faster teamwork"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.land": [
    {
      "type": 0,
      "value": "🎬 Start your first Loom recording today"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.header.conf": [
    {
      "type": 0,
      "value": "Capture context in a single click"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.header.jira": [
    {
      "type": 0,
      "value": "Capture context in a single click"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.header.jiraConf": [
    {
      "type": 0,
      "value": "Get to “done” faster with Rovo AI"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.header.land": [
    {
      "type": 0,
      "value": "Bring work to life with video"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.item1.jiraConf": [
    {
      "children": [
        {
          "type": 0,
          "value": "Take action in a flash"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Chat with Rovo AI to summarize updates, create tasks, and draft content in seconds."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.item2.jiraConf": [
    {
      "children": [
        {
          "type": 0,
          "value": "Find, don't search"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Rovo AI Search provides rich, contextual answers grounded in your org's knowledge, history, and context."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.item3.jiraConf": [
    {
      "children": [
        {
          "type": 0,
          "value": "Say “hey” to your AI teammate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Call on Rovo to tackle any task and act on insights across all your apps and integrations."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.conf": [
    {
      "type": 0,
      "value": "Start with Loom"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jira": [
    {
      "type": 0,
      "value": "Start with Loom"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jiraConf": [
    {
      "type": 0,
      "value": "Explore Rovo AI"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.land": [
    {
      "type": 0,
      "value": "Start with Loom"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.conf": [
    {
      "type": 0,
      "value": "Try it out"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.jira": [
    {
      "type": 0,
      "value": "Try it out"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.land": [
    {
      "type": 0,
      "value": "Try it out"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.conf": [
    {
      "type": 0,
      "value": "Add Loom videos as "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Smart Links"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in Jira and Confluence to keep the team in sync"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.jira": [
    {
      "type": 0,
      "value": "Add Loom videos as "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Smart Links"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in Jira and Confluence to keep the team in sync"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.land": [
    {
      "type": 0,
      "value": "Add Loom videos as "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Smart Links"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in Jira and Confluence to keep the team in sync"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.conf": [
    {
      "type": 0,
      "value": "Pro tip!"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.jira": [
    {
      "type": 0,
      "value": "Pro tip!"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.land": [
    {
      "type": 0,
      "value": "Pro tip!"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.conf": [
    {
      "type": 0,
      "value": "Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.jira": [
    {
      "type": 0,
      "value": "Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.land": [
    {
      "type": 0,
      "value": "Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.conf": [
    {
      "type": 0,
      "value": "Add clarity instantly"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.jira": [
    {
      "type": 0,
      "value": "Add clarity instantly"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.land": [
    {
      "type": 0,
      "value": "Add clarity instantly"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.conf": [
    {
      "type": 0,
      "value": "Get automated meeting recaps—with summaries and action items, so nothing slips through the cracks."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.jira": [
    {
      "type": 0,
      "value": "Get automated meeting recaps—with summaries and action items, so nothing slips through the cracks."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.land": [
    {
      "type": 0,
      "value": "Get automated meeting recaps—with summaries and action items, so nothing slips through the cracks."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.conf": [
    {
      "type": 0,
      "value": "Take notes, without writing a single word"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.jira": [
    {
      "type": 0,
      "value": "Take notes, without writing a single word"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.land": [
    {
      "type": 0,
      "value": "Take notes, without writing a single word"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.conf": [
    {
      "type": 0,
      "value": "Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.jira": [
    {
      "type": 0,
      "value": "Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.land": [
    {
      "type": 0,
      "value": "Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.conf": [
    {
      "type": 0,
      "value": "Turn recordings into action"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.jira": [
    {
      "type": 0,
      "value": "Turn recordings into action"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.land": [
    {
      "type": 0,
      "value": "Turn recordings into action"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.subheader.conf": [
    {
      "type": 0,
      "value": "How to work with AI-powered videos:"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jira": [
    {
      "type": 0,
      "value": "How to work with AI-powered videos:"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jiraConf": [
    {
      "type": 0,
      "value": "Top tips for working smarter & speedier with Rovo AI:"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.subheader.land": [
    {
      "type": 0,
      "value": "How to work with AI-powered videos in Loom:"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.conf": [
    {
      "type": 0,
      "value": "Explore now"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jira": [
    {
      "type": 0,
      "value": "Explore now"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jiraConf": [
    {
      "type": 0,
      "value": "Explore now"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.land": [
    {
      "type": 0,
      "value": "Explore Rovo AI"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.conf": [
    {
      "type": 0,
      "value": "Try out your Teamwork Collection apps today to transform how your team gets it all done."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jira": [
    {
      "type": 0,
      "value": "Try out your Teamwork Collection apps today to transform how your team gets it all done."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jiraConf": [
    {
      "type": 0,
      "value": "Try out your Teamwork Collection apps today to transform how your team gets it all done."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.land": [
    {
      "type": 0,
      "value": "Use Rovo AI to turn deliver big ideas faster and collaborate as a human-AI team. Try out Rovo AI with your collection of apps today."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.conf": [
    {
      "type": 0,
      "value": "There's no limit to what your team can do!"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jira": [
    {
      "type": 0,
      "value": "There's no limit to what your team can do!"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jiraConf": [
    {
      "type": 0,
      "value": "There's no limit to what your team can do!"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.land": [
    {
      "type": 0,
      "value": "Discover a whole new way to teamwork"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.content.conf": [
    {
      "type": 0,
      "value": "Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.content.jira": [
    {
      "type": 0,
      "value": "Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.content.jiraConf": [
    {
      "type": 0,
      "value": "Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.content.land": [
    {
      "type": 0,
      "value": "Supercharge how you work with AI-powered Search, Chat, and Agents—all integrated directly into Jira, Confluence, and Loom."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.conf": [
    {
      "type": 0,
      "value": "🤩 Everything you need to plan, sync, and launch—together"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jira": [
    {
      "type": 0,
      "value": "🤩 Everything you need to plan, sync, and launch—together"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jiraConf": [
    {
      "type": 0,
      "value": "🤩 Everything you need to plan, sync, and launch—together"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.land": [
    {
      "type": 0,
      "value": "🤩 Here's everything you need to plan, sync, and launch—together"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.header.conf": [
    {
      "type": 0,
      "value": "Go further with the power of teamwork"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.header.jira": [
    {
      "type": 0,
      "value": "Go further with the power of teamwork"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.header.jiraConf": [
    {
      "type": 0,
      "value": "Go further with the power of teamwork"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.header.land": [
    {
      "type": 0,
      "value": "Get to “done” faster with your apps + Rovo AI"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.conf": [
    {
      "type": 0,
      "value": "Explore now"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jira": [
    {
      "type": 0,
      "value": "Explore now"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jiraConf": [
    {
      "type": 0,
      "value": "Explore now"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.land": [
    {
      "type": 0,
      "value": "Explore Rovo AI"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.proTipButtonText.land": [
    {
      "type": 0,
      "value": "Read more"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.proTipContent.land": [
    {
      "type": 0,
      "value": "The Rovo guide introduces the basics of working with AI Search, Chat and agents."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.proTipHeader.land": [
    {
      "type": 0,
      "value": "Pro tip:"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.conf": [
    {
      "type": 0,
      "value": "Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jira": [
    {
      "type": 0,
      "value": "Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jiraConf": [
    {
      "type": 0,
      "value": "Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.land": [
    {
      "type": 0,
      "value": "Need help dreaming up your next big idea? Brainstorm project docs and tasks with Rovo Chat to create everything you need in the blink of an eye."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.conf": [
    {
      "type": 0,
      "value": "Share powerful, contextual updates"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jira": [
    {
      "type": 0,
      "value": "Share powerful, contextual updates"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jiraConf": [
    {
      "type": 0,
      "value": "Share powerful, contextual updates"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.land": [
    {
      "type": 0,
      "value": "Create anything in seconds!"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.conf": [
    {
      "type": 0,
      "value": "Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jira": [
    {
      "type": 0,
      "value": "Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jiraConf": [
    {
      "type": 0,
      "value": "Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.land": [
    {
      "type": 0,
      "value": "Use Rovo AI to automatically scan Confluence pages for action items and turn them into Jira tasks with just a few clicks."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.conf": [
    {
      "type": 0,
      "value": "Smash projects, as a team"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jira": [
    {
      "type": 0,
      "value": "Smash projects, as a team"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jiraConf": [
    {
      "type": 0,
      "value": "Smash projects, as a team"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.land": [
    {
      "type": 0,
      "value": "Transform pages into action"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.conf": [
    {
      "type": 0,
      "value": "Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jira": [
    {
      "type": 0,
      "value": "Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jiraConf": [
    {
      "type": 0,
      "value": "Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.land": [
    {
      "type": 0,
      "value": "Use Rovo AI to break your Jira work items into easily-achievable sub-tasks. Automatically surface related Confluence pages, and use them to create descriptions."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.conf": [
    {
      "type": 0,
      "value": "Redefine how you collaborate"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jira": [
    {
      "type": 0,
      "value": "Redefine how you collaborate"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jiraConf": [
    {
      "type": 0,
      "value": "Redefine how you collaborate"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.land": [
    {
      "type": 0,
      "value": "Instantly enhance your work"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step4Description.land": [
    {
      "type": 0,
      "value": "Create and embed a Loom right from your Confluence page (along with AI-generated notes or action items!) and keep everyone in-the-know."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.step4Title.land": [
    {
      "type": 0,
      "value": "Auto-summarize with video"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.subheader.conf": [
    {
      "type": 0,
      "value": "3 easy ways to speed up your workflows:"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jira": [
    {
      "type": 0,
      "value": "3 easy ways to speed up your workflows:"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jiraConf": [
    {
      "type": 0,
      "value": "3 easy ways to speed up your workflows:"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.subheader.land": [
    {
      "type": 0,
      "value": "Try this workflow for using Jira, Confluence, Loom, and Rovo together:"
    }
  ],
  "growth-starburst.twc-onboarding-widget.onboarding-card.dismiss-tooltip": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "growth-starburst.twc-onboarding-widget.onboarding-card.status": [
    {
      "type": 0,
      "value": "Completed"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step1.description": [
    {
      "type": 0,
      "value": "Create, update and manage Jira work directly in Pages."
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step1.header": [
    {
      "type": 0,
      "value": "Create Jira tasks directly in Pages"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step1.progressIndicator": [
    {
      "type": 0,
      "value": "1 of 3"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step2.description": [
    {
      "type": 0,
      "value": "Generate content easily and quickly with our AI-powered writing assistant. Type /rovo to try it now."
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step2.header": [
    {
      "type": 0,
      "value": "Let AI do the writing for you"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step2.progressIndicator": [
    {
      "type": 0,
      "value": "2 of 3"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step3.description": [
    {
      "type": 0,
      "value": "Loom can create a script from your page content. Record a quick video and add it to your doc to explain updates."
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step3.header": [
    {
      "type": 0,
      "value": "Share updates with video"
    }
  ],
  "growth-starburst.twc-project-pages-confluence-tour.step3.progressIndicator": [
    {
      "type": 0,
      "value": "3 of 3"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.buttonText.conf": [
    {
      "type": 0,
      "value": "Start exploring"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.buttonText.jira": [
    {
      "type": 0,
      "value": "Start exploring"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.buttonText.jiraConf": [
    {
      "type": 0,
      "value": "Start exploring"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.buttonText.land": [
    {
      "type": 0,
      "value": "Start with Jira"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.closingDescription.conf": [
    {
      "type": 0,
      "value": "See how Jira, Loom, and Rovo plug into your Confluence workflows today."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.closingDescription.jira": [
    {
      "type": 0,
      "value": "See how Confluence, Loom, and Rovo plug into your Jira workflows today."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.closingDescription.jiraConf": [
    {
      "type": 0,
      "value": "See how Loom and Rovo plug into your Jira and Confluence workflows today."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.closingDescription.land": [
    {
      "type": 0,
      "value": "Jump into Jira to create your first task"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.closingTitle.conf": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.closingTitle.jira": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.closingTitle.jiraConf": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.closingTitle.land": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.content.conf": [
    {
      "type": 0,
      "value": "Your new collection of apps supercharges productivity with work tracking across teams, async video, and AI-powered insights—all alongside Confluence."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.content.jira": [
    {
      "type": 0,
      "value": "Your new collection of apps supercharges productivity with org-wide knowledge sharing, async video, and AI-powered insights—all alongside Jira."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.content.jiraConf": [
    {
      "type": 0,
      "value": "Your new collection of apps supercharges productivity with async video and AI-powered insights—all alongside Jira & Confluence."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.content.land": [
    {
      "type": 0,
      "value": "Collaborate and achieve more—right from day one. We'll guide you step-by-step over the next few days."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.emailSubject.conf": [
    {
      "type": 0,
      "value": "🙌 You're in—welcome to Teamwork Collection!"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.emailSubject.jira": [
    {
      "type": 0,
      "value": "🙌 You're in—welcome to Teamwork Collection!"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.emailSubject.jiraConf": [
    {
      "type": 0,
      "value": "🙌 You're in—welcome to Teamwork Collection!"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.emailSubject.land": [
    {
      "type": 0,
      "value": "🙌 You're in—welcome to Teamwork Collection!"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.header.conf": [
    {
      "type": 0,
      "value": "Meet your team's new superpower"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.header.jira": [
    {
      "type": 0,
      "value": "Meet your team's new superpower"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.header.jiraConf": [
    {
      "type": 0,
      "value": "Meet your team's new superpower"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.header.land": [
    {
      "type": 0,
      "value": "Meet your team's new superpower"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.conf": [
    {
      "type": 0,
      "value": "Start exploring"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jira": [
    {
      "type": 0,
      "value": "Start exploring"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jiraConf": [
    {
      "type": 0,
      "value": "Start exploring"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.land": [
    {
      "type": 0,
      "value": "Start with Jira"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step1Description.conf": [
    {
      "type": 0,
      "value": "Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step1Description.jira": [
    {
      "type": 0,
      "value": "Create and share information effortlessly—plan better, stay aligned, and keep everything you need right at your fingertips."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step1Description.jiraConf": [
    {
      "type": 0,
      "value": "Send quick video messages that add context, save time, reduce meetings, and keep everyone in sync across time zones."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step1Description.land": [
    {
      "type": 0,
      "value": "Create "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "work items"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", which are chunks of work (just like to-dos) that you can break down into smaller, more achievable tasks."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step1Title.conf": [
    {
      "type": 0,
      "value": "Work smarter with Rovo AI"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step1Title.jira": [
    {
      "type": 0,
      "value": "Organize knowledge with Confluence"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step1Title.jiraConf": [
    {
      "type": 0,
      "value": "Share updates instantly with Loom"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step1Title.land": [
    {
      "type": 0,
      "value": "Break down your work"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step2Description.conf": [
    {
      "type": 0,
      "value": "Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step2Description.jira": [
    {
      "type": 0,
      "value": "Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step2Description.jiraConf": [
    {
      "type": 0,
      "value": "Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step2Description.land": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "fields"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to include all the important details to your work items, like due dates, assignees, priority, and more."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step2Title.conf": [
    {
      "type": 0,
      "value": "Share updates instantly with Loom"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step2Title.jira": [
    {
      "type": 0,
      "value": "Share updates instantly with Loom"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step2Title.jiraConf": [
    {
      "type": 0,
      "value": "Work smarter with Rovo AI"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step2Title.land": [
    {
      "type": 0,
      "value": "Add important details"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step3Description.conf": [
    {
      "type": 0,
      "value": "Plan and manage anything—from big projects to daily tasks—with seamless workflows, real-time tracking, and clear alignment to goals."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step3Description.jira": [
    {
      "type": 0,
      "value": "Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step3Description.land": [
    {
      "type": 0,
      "value": "Use a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "board"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to arrange work items in columns and by status, or plot work out on a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "timeline"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "calendar"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " view over months or quarters."
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step3Title.conf": [
    {
      "type": 0,
      "value": "Get it done with Jira"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step3Title.jira": [
    {
      "type": 0,
      "value": "Work smarter with Rovo AI"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.step3Title.land": [
    {
      "type": 0,
      "value": "View it your way"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.subheader.conf": [
    {
      "type": 0,
      "value": "Our expert tips for using your new apps:"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.subheader.jira": [
    {
      "type": 0,
      "value": "Our expert tips for using your new apps:"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.subheader.jiraConf": [
    {
      "type": 0,
      "value": "Our expert tips for using your new apps:"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.subheader.land": [
    {
      "type": 0,
      "value": "We recommend starting with Jira"
    }
  ],
  "growth-starburst.twc-welcome-email.message-template.email.subheaderDescription.land": [
    {
      "type": 0,
      "value": "Managing your projects starts with Jira. Start by setting things up to manage your work more efficiently:"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.add-comment.cta": [
    {
      "type": 0,
      "value": "Add comment"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.add-comment.description": [
    {
      "type": 0,
      "value": "Jump back into a recent work item and leave a comment for your team."
    }
  ],
  "growth-starburst.wac-product-activation-checklist.add-comment.title": [
    {
      "type": 0,
      "value": "Add a comment to a work item"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.create-work-item.cta": [
    {
      "type": 0,
      "value": "Create work item"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.create-work-item.description": [
    {
      "type": 0,
      "value": "Use AI to draft a work item in your most recent Jira Software project."
    }
  ],
  "growth-starburst.wac-product-activation-checklist.create-work-item.title": [
    {
      "type": 0,
      "value": "Create your first Jira work item"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.dismiss-checklist": [
    {
      "type": 0,
      "value": "Dismiss checklist"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.invite-team.cta": [
    {
      "type": 0,
      "value": "Invite team"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.invite-team.description": [
    {
      "type": 0,
      "value": "Bring teammates into Jira so everyone can collaborate in one place."
    }
  ],
  "growth-starburst.wac-product-activation-checklist.invite-team.title": [
    {
      "type": 0,
      "value": "Invite your team"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.item-completed": [
    {
      "type": 0,
      "value": "Completed"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.update-work-item.cta": [
    {
      "type": 0,
      "value": "Update work item"
    }
  ],
  "growth-starburst.wac-product-activation-checklist.update-work-item.description": [
    {
      "type": 0,
      "value": "Open a recent work item and update one of its fields."
    }
  ],
  "growth-starburst.wac-product-activation-checklist.update-work-item.title": [
    {
      "type": 0,
      "value": "Update a work item"
    }
  ],
  "jira-project-space-connected.message-templates.spotlight-description-couse": [
    {
      "type": 0,
      "value": "Create pages for your project without leaving Jira."
    }
  ],
  "jira-project-space-connected.message-templates.spotlight-description-xflow": [
    {
      "type": 0,
      "value": "Create Confluence pages within Jira. Free for 10 users."
    }
  ],
  "jira-project-space-connected.message-templates.spotlight-header-couse": [
    {
      "type": 0,
      "value": "Your project has Confluence pages"
    }
  ],
  "jira-project-space-connected.message-templates.spotlight-header-xflow": [
    {
      "type": 0,
      "value": "Add pages to your project"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far": [
    {
      "type": 0,
      "value": "What you’ve done so far in the product"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis": [
    {
      "type": 0,
      "value": "This recommendation is based on:"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions": [
    {
      "type": 0,
      "value": "What we suggest to help you get the most value from Atlassian"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body": [
    {
      "type": 0,
      "value": "Instead of manually typing meeting notes, why not try Loom to record meetings?"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header": [
    {
      "type": 0,
      "value": "Automate meeting notes"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt": [
    {
      "type": 0,
      "value": "Notepad with sparkling background"
    }
  ],
  "post-office.project-assets-ai-suggestions.empty-state": [
    {
      "type": 0,
      "value": "No suggestions available right now."
    }
  ],
  "post-office.project-assets-ai-suggestions.header.loaded": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " suggested action"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " suggested actions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "post-office.project-assets-ai-suggestions.header.loading": [
    {
      "type": 0,
      "value": "Rovo is analyzing…"
    }
  ],
  "post-office.project-assets-ai-suggestions.loom-meeting-notes.cta": [
    {
      "type": 0,
      "value": "Set up Loom"
    }
  ],
  "post-office.project-assets-ai-suggestions.loom-meeting-notes.description": [
    {
      "type": 0,
      "value": "Use Loom to record meetings and auto-create notes, so you never forget next steps."
    }
  ],
  "post-office.project-assets-ai-suggestions.loom-meeting-notes.title": [
    {
      "type": 0,
      "value": "Set up meeting notes"
    }
  ],
  "post-office.project-assets-ai-suggestions.project-plan.cta": [
    {
      "type": 0,
      "value": "Create summary"
    }
  ],
  "post-office.project-assets-ai-suggestions.project-plan.description": [
    {
      "type": 0,
      "value": "Create a project plan for your newly added epic "
    },
    {
      "type": 1,
      "value": "epicKey"
    },
    {
      "type": 0,
      "value": " to share with your team."
    }
  ],
  "post-office.project-assets-ai-suggestions.project-plan.title": [
    {
      "type": 0,
      "value": "Create a project plan"
    }
  ],
  "post-office.project-assets-ai-suggestions.toggle.hide": [
    {
      "type": 0,
      "value": "Hide"
    }
  ],
  "post-office.project-assets-ai-suggestions.toggle.show": [
    {
      "type": 0,
      "value": "Show"
    }
  ],
  "post-office.project-assets-ai-suggestions.weekly-summary.additional-count": [
    {
      "type": 0,
      "value": " +"
    },
    {
      "type": 1,
      "value": "count"
    }
  ],
  "post-office.project-assets-ai-suggestions.weekly-summary.cta": [
    {
      "type": 0,
      "value": "Create summary"
    }
  ],
  "post-office.project-assets-ai-suggestions.weekly-summary.description": [
    {
      "type": 0,
      "value": "Create a summary for completed tasks "
    },
    {
      "type": 1,
      "value": "issueKey"
    },
    {
      "type": 1,
      "value": "additionalCount"
    },
    {
      "type": 0,
      "value": " to share with leadership."
    }
  ],
  "post-office.project-assets-ai-suggestions.weekly-summary.title": [
    {
      "type": 0,
      "value": "Create a weekly summary"
    }
  ],
  "townsquare.townsquare-screen-space-flags.twc-spotlight-test.for-you-spotlight-text": [
    {
      "type": 0,
      "value": "for you spotlight"
    }
  ],
  "townsquare.townsquare-screen-space-flags.twc-spotlight-test.rovo-chat-spotlight-text": [
    {
      "type": 0,
      "value": "rovo chat spotlight"
    }
  ],
  "townsquare.townsquare-screen-space-flags.twc-spotlight-test.switcher-spotlight-text": [
    {
      "type": 0,
      "value": "switcher spotlight"
    }
  ],
  "townsquare.townsquare-twc-modal.progress": [
    {
      "type": 1,
      "value": "currentSpotlightNumber"
    },
    {
      "type": 0,
      "value": "/"
    },
    {
      "type": 1,
      "value": "numTotalSpotlights"
    }
  ],
  "townsquare.townsquare-twc-modal.twc-modal-story.for-you-spotlight-text.no-translate": [
    {
      "type": 0,
      "value": "for you spotlight"
    }
  ],
  "townsquare.townsquare-twc-modal.twc-modal-story.rovo-chat-spotlight-text.no-translate": [
    {
      "type": 0,
      "value": "rovo chat spotlight"
    }
  ],
  "townsquare.townsquare-twc-modal.twc-modal-story.switcher-spotlight-text.no-translate": [
    {
      "type": 0,
      "value": "switcher spotlight"
    }
  ],
  "townsquare.townsquare-twc-modal.twc-spotlight-test.for-you-spotlight-text.no-translate": [
    {
      "type": 0,
      "value": "for you spotlight"
    }
  ],
  "townsquare.townsquare-twc-modal.twc-spotlight-test.rovo-chat-spotlight-text.no-translate": [
    {
      "type": 0,
      "value": "rovo chat spotlight"
    }
  ],
  "townsquare.townsquare-twc-modal.twc-spotlight-test.switcher-spotlight-text.no-translate": [
    {
      "type": 0,
      "value": "switcher spotlight"
    }
  ],
  "townsquare.townsquare-twc-spotlight.progress": [
    {
      "type": 1,
      "value": "currentSpotlightNumber"
    },
    {
      "type": 0,
      "value": "/"
    },
    {
      "type": 1,
      "value": "numTotalSpotlights"
    }
  ],
  "townsquare.twc-onboarding-modal.app-switcher.body": [
    {
      "type": 0,
      "value": "Use this menu to easily switch between other Atlassian apps."
    }
  ],
  "townsquare.twc-onboarding-modal.app-switcher.heading": [
    {
      "type": 0,
      "value": "Find all your apps here"
    }
  ],
  "townsquare.twc-onboarding-modal.apps-icon-label": [
    {
      "type": 0,
      "value": "Apps"
    }
  ],
  "townsquare.twc-onboarding-modal.atlassian-home": [
    {
      "type": 0,
      "value": "Access all your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "work"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "spaces"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " in Atlassian Home"
    }
  ],
  "townsquare.twc-onboarding-modal.atlassian-logo-label": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "townsquare.twc-onboarding-modal.back-button": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "townsquare.twc-onboarding-modal.close-button-label": [
    {
      "type": 0,
      "value": "Close onboarding modal"
    }
  ],
  "townsquare.twc-onboarding-modal.confluence-feature": [
    {
      "type": 0,
      "value": "Document notes and knowledge in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Confluence"
        }
      ],
      "type": 8,
      "value": "bold"
    }
  ],
  "townsquare.twc-onboarding-modal.confluence-icon-label": [
    {
      "type": 0,
      "value": "Confluence"
    }
  ],
  "townsquare.twc-onboarding-modal.connect-integrations": [
    {
      "type": 0,
      "value": "Connect work with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "teams, AI,"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " and more"
    }
  ],
  "townsquare.twc-onboarding-modal.connect-work-title": [
    {
      "type": 0,
      "value": "Connect work across Atlassian"
    }
  ],
  "townsquare.twc-onboarding-modal.description": [
    {
      "type": 0,
      "value": "Collaborating is easier than ever with new apps and features, including AI-powered Search and Chat."
    }
  ],
  "townsquare.twc-onboarding-modal.explore-atlassian-home": [
    {
      "type": 0,
      "value": "Explore Atlassian Home"
    }
  ],
  "townsquare.twc-onboarding-modal.explore-loom": [
    {
      "type": 0,
      "value": "Explore Loom"
    }
  ],
  "townsquare.twc-onboarding-modal.for-you.body": [
    {
      "type": 0,
      "value": "Home connects work from across Atlassian, giving you an overview of what's happening across teams, goals, and projects."
    }
  ],
  "townsquare.twc-onboarding-modal.for-you.generic-heading": [
    {
      "type": 0,
      "value": "Welcome Home!"
    }
  ],
  "townsquare.twc-onboarding-modal.for-you.heading": [
    {
      "type": 0,
      "value": "Welcome Home, "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "townsquare.twc-onboarding-modal.got-it-button": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "townsquare.twc-onboarding-modal.home-icon-label": [
    {
      "type": 0,
      "value": "Home"
    }
  ],
  "townsquare.twc-onboarding-modal.illustration-alt": [
    {
      "type": 0,
      "value": "Illustration showing collaborative teamwork with connected apps and AI-powered features"
    }
  ],
  "townsquare.twc-onboarding-modal.integration-feature": [
    {
      "type": 0,
      "value": "Bring it all together with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "teams, AI,"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " and more"
    }
  ],
  "townsquare.twc-onboarding-modal.integration-icon-label": [
    {
      "type": 0,
      "value": "Integration"
    }
  ],
  "townsquare.twc-onboarding-modal.jira-confluence-features": [
    {
      "type": 0,
      "value": "Add context in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Jira"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " with detailed docs in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Confluence"
        }
      ],
      "type": 8,
      "value": "bold"
    }
  ],
  "townsquare.twc-onboarding-modal.jira-feature": [
    {
      "type": 0,
      "value": "Map out your team's work and tasks in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Jira"
        }
      ],
      "type": 8,
      "value": "bold"
    }
  ],
  "townsquare.twc-onboarding-modal.jira-icon-label": [
    {
      "type": 0,
      "value": "Jira"
    }
  ],
  "townsquare.twc-onboarding-modal.left-align-icon-label": [
    {
      "type": 0,
      "value": "Align Text Left"
    }
  ],
  "townsquare.twc-onboarding-modal.loom-add-demos": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "demos"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " and walkthroughs of your work in Jira"
    }
  ],
  "townsquare.twc-onboarding-modal.loom-bring-together": [
    {
      "type": 0,
      "value": "Bring it all together with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "teams, goals, AI"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": ", and more"
    }
  ],
  "townsquare.twc-onboarding-modal.loom-description": [
    {
      "type": 0,
      "value": "Loom makes it easy to record videos and streamline communication in the apps you already use:"
    }
  ],
  "townsquare.twc-onboarding-modal.loom-feature": [
    {
      "type": 0,
      "value": "Share and embed async video updates with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Loom"
        }
      ],
      "type": 8,
      "value": "bold"
    }
  ],
  "townsquare.twc-onboarding-modal.loom-icon-label": [
    {
      "type": 0,
      "value": "Loom"
    }
  ],
  "townsquare.twc-onboarding-modal.loom-share-updates": [
    {
      "type": 0,
      "value": "Use "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Loom"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " to easily share updates and knowledge"
    }
  ],
  "townsquare.twc-onboarding-modal.loom-title": [
    {
      "type": 0,
      "value": "Create better shareouts with Loom"
    }
  ],
  "townsquare.twc-onboarding-modal.loom-use-videos": [
    {
      "type": 0,
      "value": "Use videos to give "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "context"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " to Confluence pages"
    }
  ],
  "townsquare.twc-onboarding-modal.new-apps-one": [
    {
      "type": 0,
      "value": "Streamline work with "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "appOneName"
        }
      ],
      "type": 8,
      "value": "bold"
    }
  ],
  "townsquare.twc-onboarding-modal.new-apps-title": [
    {
      "type": 0,
      "value": "New apps and features are here"
    }
  ],
  "townsquare.twc-onboarding-modal.new-apps-two": [
    {
      "type": 0,
      "value": "Streamline work with "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "appOneName"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "appTwoName"
        }
      ],
      "type": 8,
      "value": "bold"
    }
  ],
  "townsquare.twc-onboarding-modal.next-button": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "townsquare.twc-onboarding-modal.ok-button": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "townsquare.twc-onboarding-modal.rovo-chat.body": [
    {
      "type": 0,
      "value": "You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."
    }
  ],
  "townsquare.twc-onboarding-modal.rovo-chat.heading": [
    {
      "type": 0,
      "value": "Chat with AI"
    }
  ],
  "townsquare.twc-onboarding-modal.spotlight.close-button-label": [
    {
      "type": 0,
      "value": "Close onboarding spotlight tour"
    }
  ],
  "townsquare.twc-onboarding-modal.take-a-tour-button": [
    {
      "type": 0,
      "value": "Take a tour"
    }
  ],
  "townsquare.twc-onboarding-modal.teams-icon-label": [
    {
      "type": 0,
      "value": "Integration"
    }
  ],
  "townsquare.twc-onboarding-modal.title": [
    {
      "type": 0,
      "value": "Transform teamwork, together"
    }
  ],
  "townsquare.twc-onboarding-modal.try-now-button": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "townsquare.twc-onboarding-spotlight.app-switcher.body": [
    {
      "type": 0,
      "value": "Use this menu to easily switch between other Atlassian apps."
    }
  ],
  "townsquare.twc-onboarding-spotlight.app-switcher.heading": [
    {
      "type": 0,
      "value": "Find all your apps here"
    }
  ],
  "townsquare.twc-onboarding-spotlight.back-button": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "townsquare.twc-onboarding-spotlight.close-button-label": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "townsquare.twc-onboarding-spotlight.for-you.body": [
    {
      "type": 0,
      "value": "Home connects work from across Atlassian, giving you an overview of what's happening across teams, goals, and projects."
    }
  ],
  "townsquare.twc-onboarding-spotlight.for-you.generic-heading": [
    {
      "type": 0,
      "value": "Welcome Home!"
    }
  ],
  "townsquare.twc-onboarding-spotlight.for-you.heading": [
    {
      "type": 0,
      "value": "Welcome Home, "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "townsquare.twc-onboarding-spotlight.next-button": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "townsquare.twc-onboarding-spotlight.ok-button": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "townsquare.twc-onboarding-spotlight.rovo-chat.body": [
    {
      "type": 0,
      "value": "You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."
    }
  ],
  "townsquare.twc-onboarding-spotlight.rovo-chat.heading": [
    {
      "type": 0,
      "value": "Chat with AI"
    }
  ],
  "townsquare.twc-onboarding-spotlight.try-now-button": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "townsquare.twc-onboarding-widget.chat-card.cta": [
    {
      "type": 0,
      "value": "Try Chat"
    }
  ],
  "townsquare.twc-onboarding-widget.chat-card.description": [
    {
      "type": 0,
      "value": "Get helpful answers to your questions and collaborate with AI on your work."
    }
  ],
  "townsquare.twc-onboarding-widget.chat-card.heading": [
    {
      "type": 0,
      "value": "Chat with Rovo"
    }
  ],
  "townsquare.twc-onboarding-widget.confluence-card.cta": [
    {
      "type": 0,
      "value": "Try Confluence"
    }
  ],
  "townsquare.twc-onboarding-widget.confluence-card.description": [
    {
      "type": 0,
      "value": "Create a knowledge bank available to everyone in your team."
    }
  ],
  "townsquare.twc-onboarding-widget.confluence-card.heading": [
    {
      "type": 0,
      "value": "Write docs with Confluence"
    }
  ],
  "townsquare.twc-onboarding-widget.goals-card.cta": [
    {
      "type": 0,
      "value": "Try Goals"
    }
  ],
  "townsquare.twc-onboarding-widget.goals-card.description": [
    {
      "type": 0,
      "value": "Align your work with goals to make sure you are on track."
    }
  ],
  "townsquare.twc-onboarding-widget.goals-card.heading": [
    {
      "type": 0,
      "value": "Track progress with goals"
    }
  ],
  "townsquare.twc-onboarding-widget.jira-card.cta": [
    {
      "type": 0,
      "value": "Try Jira"
    }
  ],
  "townsquare.twc-onboarding-widget.jira-card.description": [
    {
      "type": 0,
      "value": "Create project tasks to begin managing your project."
    }
  ],
  "townsquare.twc-onboarding-widget.jira-card.heading": [
    {
      "type": 0,
      "value": "Plan out tasks with Jira"
    }
  ],
  "townsquare.twc-onboarding-widget.loom-card.cta": [
    {
      "type": 0,
      "value": "Try Loom"
    }
  ],
  "townsquare.twc-onboarding-widget.loom-card.description": [
    {
      "type": 0,
      "value": "Share async video updates and reduce meetings for all."
    }
  ],
  "townsquare.twc-onboarding-widget.loom-card.heading": [
    {
      "type": 0,
      "value": "Share updates with Loom"
    }
  ],
  "townsquare.twc-onboarding-widget.search-card.cta": [
    {
      "type": 0,
      "value": "Try Search"
    }
  ],
  "townsquare.twc-onboarding-widget.search-card.description": [
    {
      "type": 0,
      "value": "Power up your searches with AI and find what you're looking for faster."
    }
  ],
  "townsquare.twc-onboarding-widget.search-card.heading": [
    {
      "type": 0,
      "value": "Find more with Search"
    }
  ],
  "townsquare.twc-onboarding-widget.studio-card.cta": [
    {
      "type": 0,
      "value": "Try Studio"
    }
  ],
  "townsquare.twc-onboarding-widget.studio-card.description": [
    {
      "type": 0,
      "value": "Build custom AI agents, automations, and more without needing to code."
    }
  ],
  "townsquare.twc-onboarding-widget.studio-card.heading": [
    {
      "type": 0,
      "value": "Automate work with Studio"
    }
  ],
  "townsquare.twc-onboarding-widget.teams-card.cta": [
    {
      "type": 0,
      "value": "Try Teams"
    }
  ],
  "townsquare.twc-onboarding-widget.teams-card.description": [
    {
      "type": 0,
      "value": "Collaborate more with teams and unlock the power of your teammates."
    }
  ],
  "townsquare.twc-onboarding-widget.teams-card.heading": [
    {
      "type": 0,
      "value": "Collaborate with teams"
    }
  ],
  "townsquare.twc-onboarding-widget.twc-card.cta": [
    {
      "type": 0,
      "value": "Watch video"
    }
  ],
  "townsquare.twc-onboarding-widget.twc-card.description": [
    {
      "type": 0,
      "value": "Not sure where to start? Find out how your apps can streamline your work."
    }
  ],
  "townsquare.twc-onboarding-widget.twc-card.heading": [
    {
      "type": 0,
      "value": "See how it all works together"
    }
  ],
  "townsquare.twc-onboarding-widget.twc-card.modal-close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "townsquare.twc-onboarding-widget.twc-card.modal-external-link": [
    {
      "type": 0,
      "value": "Open link"
    }
  ],
  "townsquare.twc-onboarding-widget.twc-card.modal-title": [
    {
      "type": 0,
      "value": "Welcome to Atlassian"
    }
  ],
  "twc-jira.email.header.alt": [
    {
      "type": 0,
      "value": "Jira"
    }
  ],
  "twc.email.header.alt": [
    {
      "type": 0,
      "value": "Teamwork Collection Atlassian"
    }
  ],
  "twc.sidenav.banner.generic.app.tiles.alt": [
    {
      "type": 0,
      "value": "App tiles illustration"
    }
  ],
  "twc.sidenav.banner.generic.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "twc.sidenav.banner.generic.cta": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "twc.sidenav.banner.generic.heading": [
    {
      "type": 0,
      "value": "Explore Teamwork Collection"
    }
  ],
  "twc.sidenav.banner.generic.subheading.confluence": [
    {
      "type": 0,
      "value": "Discover how the other apps can accelerate your workflows in Confluence."
    }
  ],
  "twc.sidenav.banner.generic.subheading.jira": [
    {
      "type": 0,
      "value": "Discover how the other apps can accelerate your workflows in Jira."
    }
  ],
  "twc.sidenav.banner.personalized.app.tiles.alt": [
    {
      "type": 0,
      "value": "App tiles illustration"
    }
  ],
  "twc.sidenav.banner.personalized.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "twc.sidenav.banner.personalized.cta": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "twc.sidenav.banner.personalized.heading": [
    {
      "type": 0,
      "value": "Explore Teamwork Collection"
    }
  ],
  "twc.sidenav.banner.personalized.subheading.confluence": [
    {
      "type": 0,
      "value": "Create with Rovo in Confluence"
    }
  ],
  "twc.sidenav.banner.personalized.subheading.jira": [
    {
      "type": 0,
      "value": "Plan your next team project in Jira"
    }
  ],
  "twc.sidenav.banner.personalized.subheading.loom": [
    {
      "type": 0,
      "value": "Setup video meetings with Loom AI"
    }
  ],
  "twc.sidenav.banner.template.xflow.decisions.heading": [
    {
      "type": 0,
      "value": "Instantly capture decisions"
    }
  ],
  "twc.sidenav.banner.template.xflow.eow.status.report.heading": [
    {
      "type": 0,
      "value": "Instantly create reports"
    }
  ],
  "twc.sidenav.banner.template.xflow.generic.heading": [
    {
      "type": 0,
      "value": "Don’t start from scratch"
    }
  ],
  "twc.sidenav.banner.template.xflow.meeting.notes.heading": [
    {
      "type": 0,
      "value": "Automate meeting notes"
    }
  ],
  "twc.sidenav.banner.template.xflow.project.plan.heading": [
    {
      "type": 0,
      "value": "Instantly create a project plan"
    }
  ],
  "twc.sidenav.banner.template.xflow.requirements.raci.heading": [
    {
      "type": 0,
      "value": "Instantly capture requirements"
    }
  ],
  "twc.solo.admin.invite.body.comment_created_v2": [
    {
      "type": 0,
      "value": "Invite your team so they can see your comments, reply, and stay in the loop!"
    }
  ],
  "twc.solo.admin.invite.body.issue_completed_v2": [
    {
      "type": 0,
      "value": "Invite your team so they can review your completed Jira ticket, leave comments, and create a new one!"
    }
  ],
  "twc.solo.admin.invite.body.issue_created_only_v2": [
    {
      "type": 0,
      "value": "Invite your team so they can review your new Jira ticket, leave comments, and help you finish it!"
    }
  ],
  "twc.solo.admin.invite.body.loom_active_v2": [
    {
      "type": 0,
      "value": "Invite your team so they can watch your Loom, leave comments, and record their own videos!"
    }
  ],
  "twc.solo.admin.invite.body.no_actions": [
    {
      "type": 0,
      "value": "Teamwork Collection is better together. Invite your team and try creating a page together, assigning a task, or recording a quick Loom!"
    }
  ],
  "twc.solo.admin.invite.body.page_edited_v2": [
    {
      "type": 0,
      "value": "Invite your team so they can review your edited doc, leave comments, and add their own ideas!"
    }
  ],
  "twc.solo.admin.invite.body.template_used_v2": [
    {
      "type": 0,
      "value": "Invite your team so they can use your template, leave comments, and add their own ideas!"
    }
  ],
  "twc.solo.admin.invite.cta": [
    {
      "type": 0,
      "value": "Invite teammates"
    }
  ],
  "twc.solo.admin.invite.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "twc.solo.admin.invite.headline.no_actions": [
    {
      "type": 0,
      "value": "Now that you have Teamwork Collection, bring in your team!"
    }
  ],
  "twc.solo.admin.invite.headline.shared_v2": [
    {
      "type": 0,
      "value": "Teams that share are "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "4x"
        }
      ],
      "type": 8,
      "value": "em"
    },
    {
      "type": 0,
      "value": " more likely to stay on track"
    }
  ],
  "twc.solo.admin.invite.hero.alt.comment_created": [
    {
      "type": 0,
      "value": "Illustration of a comment being shared with teammates"
    }
  ],
  "twc.solo.admin.invite.hero.alt.issue_completed": [
    {
      "type": 0,
      "value": "Illustration of a completed Jira issue being shared with teammates"
    }
  ],
  "twc.solo.admin.invite.hero.alt.issue_created_only": [
    {
      "type": 0,
      "value": "Illustration of a new Jira issue being shared with teammates"
    }
  ],
  "twc.solo.admin.invite.hero.alt.loom_active": [
    {
      "type": 0,
      "value": "Illustration of a Loom recording being shared with teammates"
    }
  ],
  "twc.solo.admin.invite.hero.alt.no_actions": [
    {
      "type": 0,
      "value": "Illustration of Jira, Confluence, Loom and Rovo working together"
    }
  ],
  "twc.solo.admin.invite.hero.alt.page_edited": [
    {
      "type": 0,
      "value": "Illustration of an edited document being shared with teammates"
    }
  ],
  "twc.solo.admin.invite.hero.alt.template_used": [
    {
      "type": 0,
      "value": "Illustration of a template being shared with teammates"
    }
  ],
  "twc.solo.admin.invite.preheader.comment_created": [
    {
      "type": 0,
      "value": "You've started a conversation—now bring in your team to keep the momentum going."
    }
  ],
  "twc.solo.admin.invite.preheader.issue_completed": [
    {
      "type": 0,
      "value": "You've completed a Jira ticket—now bring in your team to keep the momentum going."
    }
  ],
  "twc.solo.admin.invite.preheader.issue_created_only": [
    {
      "type": 0,
      "value": "You've created a Jira ticket—now bring in your team to keep the momentum going."
    }
  ],
  "twc.solo.admin.invite.preheader.loom_active": [
    {
      "type": 0,
      "value": "You've recorded a Loom—now bring in your team to keep the momentum going."
    }
  ],
  "twc.solo.admin.invite.preheader.no_actions": [
    {
      "type": 0,
      "value": "Bring in your team to collaborate across your apps"
    }
  ],
  "twc.solo.admin.invite.preheader.page_edited": [
    {
      "type": 0,
      "value": "You've edited a doc—now bring in your team to keep the momentum going."
    }
  ],
  "twc.solo.admin.invite.preheader.template_used": [
    {
      "type": 0,
      "value": "You've set up a template—now bring in your team to keep the momentum going."
    }
  ],
  "twc.solo.admin.invite.secondary.body": [
    {
      "type": 0,
      "value": "Invite your teammates to open up the conversation."
    }
  ],
  "twc.solo.admin.invite.secondary.heading": [
    {
      "type": 0,
      "value": "Teamwork Collection’s better together"
    }
  ],
  "twc.solo.admin.invite.signoff": [
    {
      "type": 0,
      "value": "The Atlassian Team"
    }
  ],
  "twc.solo.admin.invite.subject.comment_created": [
    {
      "type": 0,
      "value": "👥 Keep your team in the loop"
    }
  ],
  "twc.solo.admin.invite.subject.issue_completed": [
    {
      "type": 0,
      "value": "👥 Keep your team in the loop"
    }
  ],
  "twc.solo.admin.invite.subject.issue_created_only": [
    {
      "type": 0,
      "value": "👥 Keep your team in the loop"
    }
  ],
  "twc.solo.admin.invite.subject.loom_active": [
    {
      "type": 0,
      "value": "👥 Keep your team in the loop"
    }
  ],
  "twc.solo.admin.invite.subject.no_actions": [
    {
      "type": 0,
      "value": "👥 Teamwork Collection is better together"
    }
  ],
  "twc.solo.admin.invite.subject.page_edited": [
    {
      "type": 0,
      "value": "👥 Keep your team in the loop"
    }
  ],
  "twc.solo.admin.invite.subject.template_used": [
    {
      "type": 0,
      "value": "👥 Keep your team in the loop"
    }
  ]
}